export const formatNumberToEuropeanStyle = (number) => {
    return number?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 9,
        useGrouping: true,
    });
}